"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBarcodeImageUrl = exports.createCouponDownloadUrl = exports.mapCodes = void 0;
const mapCodes = (codes) => {
    if (!codes || codes.length === 0) {
        return [];
    }
    return codes.map((code) => {
        const temp = code.split('|');
        if (temp.length === 1) {
            return {
                codeType: 'CODE',
                couponKey: null,
                barcodeValue: temp[0],
                humanReadable: temp[0]
            };
        }
        else {
            return {
                codeType: temp[0],
                couponKey: temp[1],
                barcodeValue: temp[2],
                humanReadable: temp[3]
            };
        }
    });
};
exports.mapCodes = mapCodes;
const createCouponDownloadUrl = (couponKey, barcodeValue, humanReadable) => `/inventory/api/v1/coupons/render/${couponKey}/${barcodeValue}/${humanReadable}`;
exports.createCouponDownloadUrl = createCouponDownloadUrl;
const createBarcodeImageUrl = (couponKey, barcodeValue) => `/inventory/api/v1/coupons/render/${couponKey}/${barcodeValue}`;
exports.createBarcodeImageUrl = createBarcodeImageUrl;
//# sourceMappingURL=util.js.map